export const timestampsMap: GenericObject = {
	created_at: "createdAt",
	updated_at: "updatedAt",
};
